"use client";

import React from 'react';
import Image from 'next/image';

import { useLocale } from "@/context/LocaleContext";

export default function GiftRegistry() {
  const { t } = useLocale(); 

  return (
    <div className="w-full">
      <section className="w-full bg-gray-50 py-16 md:py-24 -mt-10 border-y border-gray-100">
        <div className="max-w-[1100px] mx-auto px-4 md:px-8">
          <div className="flex flex-col md:flex-row items-center gap-12 lg:gap-20">
            <div className="w-full md:w-[45%] flex justify-center">
              <div className="relative w-full max-w-[450px] aspect-[4/5]">
                <Image 
                  src="/images/cta/kado-fisik.webp" 
                  alt="Cara Kerja Titip Kado Otomatis" 
                  fill 
                  className="object-contain drop-shadow-xl" 
                />
              </div>
            </div>

            <div className="w-full md:w-[55%]">
              <h2 className="text-3xl md:text-4xl lg:text-[2.4rem] font-extrabold text-gray-900 mb-8 leading-tight tracking-tight">
                {t("GiftRegistry.how_it_works") || "Bagaimana Cara Kerjanya?"}
              </h2>
              
              <div className="space-y-6 lg:space-y-8">
                {/* Langkah 1 */}
                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">1.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("GiftRegistry.step1_title") || "Tamu Memilih Kado"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("GiftRegistry.step1_desc") || "Tamu dapat memilih kado yang tersedia langsung dari undangan digital."}
                    </p>
                  </div>
                </div>

                {/* Langkah 2 */}
                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">2.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("GiftRegistry.step2_title") || "Kado Disiapkan oleh Elynk"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("GiftRegistry.step2_desc") || "Setelah pembelian, Elynk akan menyiapkan kado sesuai pesanan."}
                    </p>
                  </div>
                </div>

                {/* Langkah 3 */}
                <div className="flex items-start gap-4 lg:gap-5">
                  <span className="text-xl md:text-2xl font-black text-gray-900 mt-0.5">3.</span>
                  <div>
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-1.5">
                      {t("GiftRegistry.step3_title") || "Pengiriman ke Alamat Tujuan"}
                    </h3>
                    <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                      {t("GiftRegistry.step3_desc") || "Kado dikirim langsung ke alamat pemilik acara atau alamat yang telah ditentukan."}
                    </p>
                  </div>
                </div>
              </div>
              
              {/* Tambahan: Transparan & Mudah Dipantau */}
              <div className="mt-12">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
                  {t("GiftRegistry.transparent_title") || "Transparan & Mudah Dipantau"}
                </h3>
                <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px] mb-3">
                  {t("GiftRegistry.transparent_desc_1") || "Baik tamu maupun pemilik acara akan mendapatkan:"}
                </p>
                <ul className="list-disc pl-5 space-y-2 text-gray-700 text-[15px] md:text-[16px] lg:text-[17px] mb-4">
                  <li>{t("GiftRegistry.transparent_li_1") || "Informasi status pengiriman"}</li>
                  <li>{t("GiftRegistry.transparent_li_2") || "Link tracking kado secara realtime"}</li>
                </ul>
                <p className="text-gray-700 leading-relaxed text-[15px] md:text-[16px] lg:text-[17px]">
                  {t("GiftRegistry.transparent_desc_2") || "Semua pihak bisa memantau proses pengiriman tanpa perlu bertanya satu sama lain."}
                </p>
              </div>

            </div>

          </div>
        </div>
      </section>

      <section className="w-full bg-white py-16 md:py-24">
        <div className="max-w-[1200px] mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-4xl lg:text-[2.8rem] font-extrabold text-gray-900 mb-16 md:mb-20 text-center tracking-tight">
            {t("GiftRegistry.main_benefits_title") || "Keuntungan Utama"}
          </h2>

          <div className="flex flex-wrap justify-center md:gap-8 gap-12 pt-6">
            
            {/* CARD 1 */}
            <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 pt-14 hover:shadow-md transition-shadow duration-300 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.5px)] flex-shrink-0">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center">
                <div className="w-10 h-10 relative">
                  <Image src="/images/icons/mail-send.svg" alt="Tanpa Koordinasi Manual" fill className="object-contain" />
                </div>
              </div>
              <h3 className="text-[1.15rem] md:text-[1.25rem] font-bold text-gray-900 mb-3 leading-snug">
                {t("GiftRegistry.card1_title") || "Tanpa Koordinasi Manual"}
              </h3>
              <p className="text-gray-700 text-[15px] leading-relaxed mb-2">
                {t("GiftRegistry.card1_desc_1") || "Tidak perlu lagi:"}
              </p>
              <ul className="list-disc pl-5 space-y-1 text-gray-700 text-[14.5px] leading-relaxed mb-3">
                <li>{t("GiftRegistry.card1_li_1") || "Bertanya alamat pengiriman"}</li>
                <li>{t("GiftRegistry.card1_li_2") || "Mengatur kurir secara terpisah"}</li>
                <li>{t("GiftRegistry.card1_li_3") || "Mengonfirmasi status pengiriman satu per satu"}</li>
              </ul>
              <p className="text-gray-700 text-[14.5px] font-medium leading-relaxed">
                {t("GiftRegistry.card1_desc_2") || "Semua sudah diurus oleh sistem."}
              </p>
            </div>

            {/* CARD 2 */}
            <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 pt-14 hover:shadow-md transition-shadow duration-300 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.5px)] flex-shrink-0">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center">
                <div className="w-10 h-10 relative">
                  <Image src="/images/icons/groups.svg" alt="Pengalaman Tamu Lebih Nyaman" fill className="object-contain" />
                </div>
              </div>
              <h3 className="text-[1.15rem] md:text-[1.25rem] font-bold text-gray-900 mb-3 leading-snug">
                {t("GiftRegistry.card2_title") || "Pengalaman Tamu Lebih Nyaman"}
              </h3>
              <p className="text-gray-700 text-[15px] leading-relaxed">
                {t("GiftRegistry.card2_desc") || "Tamu bisa memberikan kado meskipun tidak hadir secara langsung di acara."}
              </p>
            </div>

            {/* CARD 3 */}
            <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 pt-14 hover:shadow-md transition-shadow duration-300 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.5px)] flex-shrink-0">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center">
                <div className="w-10 h-10 relative">
                  <Image src="/images/icons/note.svg" alt="Lebih Rapi untuk Pemilik Acara" fill className="object-contain" />
                </div>
              </div>
              <h3 className="text-[1.15rem] md:text-[1.25rem] font-bold text-gray-900 mb-3 leading-snug">
                {t("GiftRegistry.card3_title") || "Lebih Rapi untuk Pemilik Acara"}
              </h3>
              <p className="text-gray-700 text-[15px] leading-relaxed">
                {t("GiftRegistry.card3_desc") || "Pemilik acara menerima kado dengan pengiriman yang terorganisir dan tercatat."}
              </p>
            </div>

            {/* CARD 4 */}
            <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 pt-14 hover:shadow-md transition-shadow duration-300 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.5px)] flex-shrink-0 mt-2 md:mt-6">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center">
                <div className="w-10 h-10 relative">
                  <Image src="/images/icons/pas-ad.svg" alt="Cocok Digunakan Untuk" fill className="object-contain" />
                </div>
              </div>
              <h3 className="text-[1.15rem] md:text-[1.25rem] font-bold text-gray-900 mb-3 leading-snug">
                {t("GiftRegistry.card4_title") || "Cocok Digunakan Untuk"}
              </h3>
              <ul className="list-disc pl-5 space-y-1.5 text-gray-700 text-[14.5px] leading-relaxed">
                <li>{t("GiftRegistry.card4_li_1") || "Pernikahan & acara keluarga"}</li>
                <li>{t("GiftRegistry.card4_li_2") || "Acara dengan tamu di luar kota"}</li>
                <li>{t("GiftRegistry.card4_li_3") || "Event profesional & corporate"}</li>
                <li>{t("GiftRegistry.card4_li_4") || "Acara dengan jumlah tamu besar"}</li>
              </ul>
            </div>

            {/* CARD 5 */}
            <div className="relative bg-[#FAFAFA] rounded-[32px] p-8 pt-14 hover:shadow-md transition-shadow duration-300 w-full md:w-[calc(50%-16px)] lg:w-[calc(33.333%-21.5px)] flex-shrink-0 mt-2 md:mt-6">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2 w-16 h-16 bg-white rounded-2xl shadow-[0_8px_20px_rgba(0,0,0,0.06)] border border-gray-50 flex items-center justify-center">
                <div className="w-10 h-10 relative">
                  <Image src="/images/icons/setting-auto-share.svg" alt="Terintegrasi dengan Sistem Undangan" fill className="object-contain" />
                </div>
              </div>
              <h3 className="text-[1.15rem] md:text-[1.25rem] font-bold text-gray-900 mb-3 leading-snug">
                {t("GiftRegistry.card5_title") || "Terintegrasi dengan Sistem Undangan"}
              </h3>
              <p className="text-gray-700 text-[15px] leading-relaxed mb-2">
                {t("GiftRegistry.card5_desc_1") || "Titip Kado Otomatis terhubung langsung dengan:"}
              </p>
              <ul className="list-disc pl-5 space-y-1 text-gray-700 text-[14.5px] leading-relaxed mb-3">
                <li className="font-semibold">{t("GiftRegistry.card5_li_1") || "Amplop Digital Otomatis"}</li>
                <li className="font-semibold">{t("GiftRegistry.card5_li_2") || "Sebar otomatis via WhatsApp"}</li>
                <li className="font-semibold">{t("GiftRegistry.card5_li_3") || "Dashboard laporan hadiah"}</li>
              </ul>
              <p className="text-gray-700 text-[14.5px] font-medium leading-relaxed">
                {t("GiftRegistry.card5_desc_2") || "Semua hadiah tercatat rapi dalam satu sistem."}
              </p>
            </div>

          </div>
        </div>
      </section>

    </div>
  );
}